/* eslint-disable i18next/no-literal-string */

import { ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Language, setLanguage, useLanguage } from "@/hooks/use-language";

export function LanguagePicker() {
  const language = useLanguage();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center gap-6 text-white">
        <img
          src={`/${language}.svg`}
          className="w-[70px] h-[70px] rounded-full"
        />
        <ChevronDown className="w-[50px] h-[50px] [&_*]:text-white" />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <LanugageItem label="EN" icon="/en.svg" lang="en" />
        <LanugageItem label="HU" icon="/hu.svg" lang="hu" />
        <LanugageItem label="DE" icon="/de.svg" lang="de" />
        <LanugageItem label="SK" icon="/sk.svg" lang="sk" />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

function LanugageItem({
  label,
  icon,
  lang,
}: {
  label: string;
  icon: string;
  lang: Language;
}) {
  return (
    <DropdownMenuItem
      className="flex items-center gap-2 font-bold"
      onClick={() => setLanguage(lang)}
    >
      <img className="w-[70px] h-[70px] rounded-full" src={icon} />
      <span className="text-[24px]">{label}</span>
    </DropdownMenuItem>
  );
}
